import {
  AvisEditableListDescriptionList,
  AvisEditableListTable,
} from "./components";
import {
  IAvisEditableListFieldArrayProps,
  IEditableListRowState,
} from "./types";

export function AvisEditableListComponentView<
  T extends object,
  P extends IEditableListRowState,
>(props: Readonly<IAvisEditableListFieldArrayProps<T, P>>): JSX.Element {
  const { view } = props;

  if (view === "description-list")
    return <AvisEditableListDescriptionList {...props} />;

  return <AvisEditableListTable {...props} />;
}
